import { Typography, Box } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

export const CustomArrowTitle = ({ text }: { text: string }) => {
  return (
    <Box sx={{ display: "inline-flex", alignItems: "center", marginTop: 2 }}>
      <PlayArrowIcon sx={{ color: "primary.main", marginRight: 1 }} />
      <Typography variant="body1" fontWeight="bold">
        {text}
      </Typography>
    </Box>
  );
};
